import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import {
  FavoriteBorder,
  Share,
  Call,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  MoreVert,
  DeleteOutline,
  AccessTime as AccessTimeIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import RocketIcon from '@mui/icons-material/RocketLaunch';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWork';
import StraightenOutlinedIcon from '@mui/icons-material/Straighten';
import ExploreOutlinedIcon from '@mui/icons-material/Explore';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoad';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAlt';
import TagOutlinedIcon from '@mui/icons-material/Tag';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import axios from 'axios';
import buildingImage from './../../../../Images/house.jpeg';
import CustomSearchBar from './../../Lease Module/CustomSearch';
import BottomNavbar from './../../Post Module/FormsBottomNavbar';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';
import CopyFailureAlert from '../../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../../Alertpage/CopyAlert/CopySuccessAlert';
import ShareCopySuccessAlert from '../../Alertpage/ShareAlert/ShareCopySuccessAlert';
import ShareCopyFailureAlert from '../../Alertpage/ShareAlert/ShareCopyFailureAlert';
import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';
import BoostFailureAlert from '../../Alertpage/CopyAlert/BoostFailureAlert';
import BoostSuccessAlert from '../../Alertpage/CopyAlert/BoostAlert';

const API_BASE_URL = 'https://landnest.net:7000/api';

const RentPropertyCard = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPropertyId, setMenuPropertyId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  // Alert States
  const [showBoostSuccess, setShowBoostSuccess] = useState(false);
  const [showBoostFailure, setShowBoostFailure] = useState(false);
  const [boostLoading, setBoostLoading] = useState(false);
  const [showShareFailure, setShowShareFailure] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showShareSuccess, setShowShareSuccess] = useState(false);

  const colors = {
    primary: '#3B2314',
    gold: '#B8860B',
    goldSoft: 'rgba(184,134,11,0.10)',
    background: 'rgb(239, 231, 221)',
    cardBackground: '#FFFFFF',
    line: '#E8E5E0',
    textDark: '#1a1a1a',
    textMuted: '#8a8a8a',
    danger: '#E74C3C',
    approved: '#2E7D32',
    approvedBg: '#E8F5E9',
    pending: '#F57C00',
    pendingBg: '#FFF3E0',
    rejected: '#C62828',
    rejectedBg: '#FFEBEE',
    specBg: '#FAF8F5',
  };

  // ==================== HELPERS ====================
  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const calculateDaysLeft = (expiredDate) => {
    if (!expiredDate) return null;
    const now = new Date();
    const expiry = new Date(expiredDate);
    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

 const formatDate = (dateString) => {
  if (!dateString) return 'Not specified';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Not specified';

  const now = new Date();
  const diffMs = now - date;

  if (diffMs < 0) return 'Just now'; // future guard

  const diffSecs  = Math.floor(diffMs / 1000);
  const diffMins  = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays  = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffSecs < 60)   return 'Just now';
  if (diffMins < 60)   return `${diffMins}m ago`;
  if (diffHours < 24)  return `${diffHours}h ago`;
  if (diffDays < 7)    return `${diffDays}d ago`;
  if (diffDays < 30)   return `${Math.floor(diffDays / 7)}w ago`;

  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

 const formatDateLong = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

  const getStatusStyles = (status) => {
    const s = (status || '').toLowerCase();
    switch (s) {
      case 'approved':
        return {
          color: colors.approved,
          bg: colors.approvedBg,
          border: colors.approved,
          icon: <CheckCircleIcon sx={{ fontSize: 13 }} />,
          label: 'Approved',
        };
      case 'rejected':
        return {
          color: colors.rejected,
          bg: colors.rejectedBg,
          border: colors.rejected,
          icon: <CancelIcon sx={{ fontSize: 13 }} />,
          label: 'Rejected',
        };
      default:
        return {
          color: colors.pending,
          bg: colors.pendingBg,
          border: colors.pending,
          icon: <HourglassEmptyIcon sx={{ fontSize: 13 }} />,
          label: 'Pending',
        };
    }
  };

  // ==================== API HANDLERS ====================
  const handleShare = async (event, property) => {
    event.stopPropagation();
    const propertyUrl = `${window.location.origin}/rent-description/${property.id}`;
    try {
      await navigator.clipboard.writeText(propertyUrl);
      setAlertMessage('Property link copied successfully!');
      setShowShareSuccess(true);
      setShowShareFailure(false);
    } catch (error) {
      setAlertMessage('Failed to copy property link');
      setShowShareFailure(true);
      setShowShareSuccess(false);
    }
  };

  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };

  const handleEdit = () => {
    navigate(`/user-edit-rent/${menuPropertyId}`);
  };

  const handleDelete = async () => {
    if (!menuPropertyIdToDelete) return;
    try {
      const response = await fetch(`${BASE_URL}/property/${menuPropertyIdToDelete}/`, {
        method: 'DELETE',
      });
      if (response.ok) {
        setProperties((prev) => prev.filter((p) => p.id !== menuPropertyIdToDelete));
        setAlertMessage(`Property ID ${menuPropertyIdToDelete} deleted successfully.`);
        setShowDeleteSuccess(true);
        fetchData();
      } else {
        const errorData = await response.json();
        setAlertMessage(`Failed to delete property ID ${menuPropertyIdToDelete}. Reason: ${errorData.detail || 'Unknown error'}`);
        setShowDeleteFailure(true);
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      setAlertMessage('An error occurred while trying to delete the property.');
      setShowDeleteFailure(true);
    } finally {
      setMenuPropertyIdToDelete(null);
      handleMenuClose();
    }
  };

  const handleBoostProperty = async () => {
    setBoostLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/boost-property/`, { user_id: userId });
      setAlertMessage('Property boosted successfully!');
      setShowBoostSuccess(true);
    } catch (error) {
      setAlertMessage('Failed to boost property. Please try again.');
      setShowBoostFailure(true);
    } finally {
      setBoostLoading(false);
    }
  };

  const handleCallClick = async (e, property) => {
    e.stopPropagation();
    try {
      if (property.mobile_no) {
        await navigator.clipboard.writeText(property.mobile_no);
        setAlertMessage(`Copied: ${property.mobile_no}`);
        setShowSuccess(true);
        setShowFailure(false);
      } else {
        setAlertMessage('Mobile number not available');
        setShowFailure(true);
        setShowSuccess(false);
      }
    } catch (error) {
      setAlertMessage('Failed to copy mobile number');
      setShowFailure(true);
      setShowSuccess(false);
    }
  };

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/wishlist-users/${propertyId}`);
  };

  const handleMatchingBuyersClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/matching-buyers/${propertyId}`);
  };

  const handleViewListClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/viewlistpage/${propertyId}`);
  };

  const handleExtensionClick = (e) => {
    e.stopPropagation();
    navigate('/user-subscription');
  };

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => {
      const currentIndex = prev[propertyId];
      const property = properties.find((p) => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % property.images.length;
      return { ...prev, [propertyId]: nextIndex };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => {
      const currentIndex = prev[propertyId];
      const property = properties.find((p) => p.id == propertyId);
      const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
      return { ...prev, [propertyId]: prevIndex };
    });
  };

  const openGoogleMapsWithDirections = (destLat, destLng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLat = position.coords.latitude;
          const currentLng = position.coords.longitude;
          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destLat},${destLng}&travelmode=driving`;
          window.open(googleMapsUrl, '_blank');
        },
        (error) => {
          console.error('Error getting location:', error);
          alert('Could not get your location. Please allow location access.');
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };

  const getPropertyImages = async (propertyId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/properties/${propertyId}/images`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
      return data;
    } catch (error) {
      console.error('API Error fetching images:', error);
      return { success: false, images: [] };
    }
  };

  // ==================== FETCH DATA ====================
  const fetchData = async () => {
    try {
      setLoading(true);
      const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
      setCategories(categoriesResponse.data);

      const propertiesResponse = await axios.get(`${API_BASE_URL}/api/properties/user/${userId}?type=rent`);
      const cartResponse = await axios.get(`${BASE_URL}/user-cart/`);
      const cartItems = cartResponse.data;
      const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
      const enquiries = enquiriesResponse.data;

      const activitiesResponse = await axios.get(`${BASE_URL}/activities/`);
      const activities = activitiesResponse.data.data;
      let subscriptions = [];
      try {
        const plansResponse = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
        subscriptions = plansResponse.data || [];
      } catch (err) {
        console.log('No subscription data found for rent');
      }

      const userProperties = propertiesResponse.data.data || propertiesResponse.data;
      const filtered = userProperties
        .filter((item) => item.created_at)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      const parsed = await Promise.all(
        filtered.map(async (item) => {
          const wishlistCount = cartItems.filter((cartItem) => cartItem.property_id === item.property_id).length;

          const matchingBuyersCount = enquiries.filter((enquiry) => {
            const propertyCategory = categoriesResponse.data.find((cat) => cat.category_id == item.category_id)?.category;
            const typeMatch = enquiry.property_type && propertyCategory && enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();
            const budgetMatch = enquiry.min_budget && enquiry.max_budget && item.price && (item.price >= enquiry.min_budget && item.price <= enquiry.max_budget);
            const locationMatch = () => {
              if (!enquiry.lat || !enquiry.long || !item.lat || !item.long) return false;
              const propLat = parseFloat(item.lat);
              const propLong = parseFloat(item.long);
              const enqLat = parseFloat(enquiry.lat);
              const enqLong = parseFloat(enquiry.long);
              const R = 6371;
              const dLat = ((enqLat - propLat) * Math.PI) / 180;
              const dLon = ((enqLong - propLong) * Math.PI) / 180;
              const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos((propLat * Math.PI) / 180) * Math.cos((enqLat * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
              return R * c <= 10;
            };
            return typeMatch && budgetMatch && locationMatch();
          }).length;

          const parseCoord = (coord) => {
            if (!coord) return null;
            return parseFloat(coord.replace(/"/g, '').replace(':', '.'));
          };

          const matchedCategory = categoriesResponse.data.find((cat) => cat.category_id == item.category_id);
          const categoryName = matchedCategory ? matchedCategory.category : 'Property';

          // Days Left Logic
          const postedBy = item.posted_by?.replace(/"/g, '') || '';
          const requiredUserType = postedBy.toLowerCase() === 'agent' ? 'Agent' : 'Individual Owner/Builder';
          const matchedSub = subscriptions.find((sub) => sub.status === true && sub.user_type === requiredUserType);
          const daysLeftForProperty = matchedSub?.expired_date ? calculateDaysLeft(matchedSub.expired_date) : null;

          let images = [buildingImage];
          try {
            const imageResponse = await getPropertyImages(item.property_id);
            if (imageResponse.success && imageResponse.images && imageResponse.images.length > 0) {
              images = imageResponse.images.map((img) => (img.startsWith('http') ? img : `${BASE_URL}${img.startsWith('/') ? '' : '/'}${img}`));
            } else if (item.property_images?.length > 0) {
              images = item.property_images.map((img) => `${BASE_URL}${img.image}`);
            }
          } catch (imgError) {
            if (item.property_images?.length > 0) {
              images = item.property_images.map((img) => `${BASE_URL}${img.image}`);
            }
          }

          return {
            id: item.property_id,
            title: categoryName,
            location: item.location || 'Not specified',
            price: item.price,
            date: item.created_at,
            facing: item.facing?.replace(/"/g, '') || 'N/A',
            area: item.site_area ? `${item.site_area} ${item.units === 'ft' ? 'Sq ft' : item.units || 'sq ft'}` : 'N/A',
            max_acres: item.max_acres ? `${item.max_acres} acres` : 'N/A',
            posted_by: postedBy || 'Agent',
            lat: parseCoord(item.lat),
            long: parseCoord(item.long),
            mobile_no: item.mobile_no,
            property_name: item.property_name,
            images: images,
            propertyData: item,
            wishlistCount: wishlistCount,
            matchingBuyersCount: matchingBuyersCount,
            admin_status: item.Admin_status || 'Pending',
            daysLeft: daysLeftForProperty,
            viewCount: [
              ...new Set(
                activities
                  .filter(
                    (activity) =>
                      activity.property_id === item.property_id &&
                      activity.activity_type === 'Description' &&
                      activity.user_id !== userId
                  )
                  .map((activity) => activity.user_id)
              ),
            ].length,
          };
        })
      );

      setProperties(parsed);
      const initialIndexes = {};
      parsed.forEach((property) => {
        initialIndexes[property.id] = 0;
      });
      setCurrentImageIndex(initialIndexes);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [userId]);

  const filteredProperties = properties.filter(
    (property) =>
      property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      property.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // ==================== SPEC CELL ====================
  const SpecCell = ({ icon, label, value, index, total }) => (
    <Box
      sx={{
        px: 1.2,
        py: 1,
        position: 'relative',
        minWidth: 0,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.8,
        ...(index % 2 === 0 &&
          index !== total - 1 && {
            '&::after': {
              content: '""',
              position: 'absolute',
              right: 0,
              top: '18%',
              height: '64%',
              width: '1px',
              backgroundColor: colors.line,
            },
          }),
        ...(index < total - (total % 2 === 0 ? 2 : 1) && {
          borderBottom: `1px solid ${colors.line}`,
        }),
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: '6px',
          backgroundColor: '#F3EFE8',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          mt: 0.2,
          color: '#8a7a5c',
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '0.6rem',
            color: colors.textMuted,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            fontWeight: 600,
            mb: 0.2,
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.78rem',
            fontWeight: 700,
            color: colors.textDark,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {value || 'Not specified'}
        </Typography>
      </Box>
    </Box>
  );

  // ==================== RENDER CARD (UNIFIED UI) ====================
  const renderRentPropertyCard = (property) => {
    const status = getStatusStyles(property.admin_status);
    const daysLeft = property.daysLeft;

    const specs = [
      {
        label: 'Property Type',
        value: property.title,
        icon: <HomeWorkOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Area',
        value: property.area || property.max_acres,
        icon: <StraightenOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Facing',
        value: property.facing,
        icon: <ExploreOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Posted By',
        value: property.posted_by,
        icon: <PeopleAltOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Property Name',
        value: property.property_name,
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: 'Property ID',
        value: property.id ? `#${property.id}` : null,
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
    ];

    return (
      <Card
        key={property.id}
        onClick={(e) => {
          const isInteractiveElement =
            e.target.closest('button') ||
            e.target.closest('svg') ||
            e.target.closest('.MuiMenu-root') ||
            e.target.closest('.MuiMenuItem-root');
          if (!isInteractiveElement) {
            navigate(`/rent-description/${property.id}`, {
              state: { propertyId: property.id, property: property.propertyData },
            });
          }
        }}
        sx={{
          mb: 1.5,
          mx: 1,
          borderRadius: '14px',
          backgroundColor: colors.cardBackground,
          border: `1px solid ${colors.line}`,
          boxShadow: '0 2px 10px rgba(0,0,0,0.07)',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0 6px 18px rgba(0,0,0,0.13)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          {/* ============ TOP ROW: IMAGE (LEFT) + DETAILS (RIGHT) ============ */}
          <Box
            sx={{
              display: 'flex',
              gap: 1.2,
              p: 1.2,
              height: 210,
              boxSizing: 'border-box',
            }}
          >
            {/* ── Image column ── */}
            <Box
              sx={{
                position: 'relative',
                width: '42%',
                height: '100%',
                flexShrink: 0,
                borderRadius: '10px',
                overflow: 'hidden',
                backgroundColor: '#F5F5F5',
              }}
            >
              <CardMedia
                component="img"
                image={property.images[currentImageIndex[property.id]]}
                alt="Property"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />

              {/* Share / More icons top-right */}
              <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.5 }}>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.9)',
                    width: 26,
                    height: 26,
                    '&:hover': { bgcolor: '#fff' },
                  }}
                  onClick={(e) => handleShare(e, property)}
                >
                  <Share sx={{ fontSize: 14 }} />
                </IconButton>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.9)',
                    width: 26,
                    height: 26,
                    '&:hover': { bgcolor: '#fff' },
                  }}
                  onClick={(e) => handleMenuOpen(e, property.id)}
                >
                  <MoreVert sx={{ fontSize: 14 }} />
                </IconButton>
              </Box>

              {/* Photo count bottom-left */}
              {property.images.length > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    backgroundColor: 'rgba(0,0,0,0.65)',
                    color: '#FFFFFF',
                    fontSize: '0.6rem',
                    fontWeight: 600,
                    px: 0.8,
                    py: 0.3,
                    borderRadius: '5px',
                    lineHeight: 1.1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.3,
                  }}
                >
                  <CollectionsOutlinedIcon sx={{ fontSize: 11 }} />
                  {currentImageIndex[property.id] + 1} / {property.images.length}
                </Box>
              )}

              {/* Carousel arrows */}
              {property.images.length > 1 && (
                <>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: 4,
                      opacity: 0,
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(255,255,255,0.5)',
                      backdropFilter: 'blur(2px)',
                      transition: 'opacity 0.2s',
                      '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
                    }}
                    onClick={(e) => handlePrevImage(property.id, e)}
                  >
                    <ChevronLeft fontSize="small" />
                  </IconButton>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      right: 4,
                      opacity: 0,
                      transform: 'translateY(-50%)',
                      backgroundColor: 'rgba(255,255,255,0.5)',
                      backdropFilter: 'blur(2px)',
                      transition: 'opacity 0.2s',
                      '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.8)' },
                    }}
                    onClick={(e) => handleNextImage(property.id, e)}
                  >
                    <ChevronRight fontSize="small" />
                  </IconButton>
                </>
              )}

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClick={(e) => e.stopPropagation()}
              >
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenuPropertyIdToDelete(property.id);
                    setShowDeleteConfirm(true);
                    handleMenuClose();
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>

            {/* ── Details column ── */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                gap: 0.6,
              }}
            >
              {/* status + posted time */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 0.6,
                  flexWrap: 'wrap',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.4,
                    px: 0.8,
                    py: 0.25,
                    borderRadius: '6px',
                    border: `1px solid ${status.border}`,
                    backgroundColor: status.bg,
                    color: status.color,
                  }}
                >
                  {status.icon}
                  <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, lineHeight: 1.1 }}>
                    {status.label}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                  <AccessTimeIcon sx={{ fontSize: 11, color: colors.textMuted }} />
                  <Typography sx={{ fontSize: '0.62rem', color: colors.textMuted }}>
                    {formatDate(property.date)}
                  </Typography>
                </Box>
              </Box>

              {/* title */}
              <Typography
                sx={{
                  fontSize: '0.92rem',
                  fontWeight: 800,
                  color: colors.textDark,
                  lineHeight: 1.25,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {property.title}-{truncateText(property.property_name, 17)}
              </Typography>

              {/* location */}
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.4 }}>
                <LocationOn
                  sx={{ fontSize: 13, color: colors.textMuted, mt: '1px', flexShrink: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: '0.68rem',
                    color: '#666',
                    lineHeight: 1.3,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {property.location}
                </Typography>
              </Box>

              {/* date */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography sx={{ fontSize: '0.66rem', color: '#666' }}>
                  {formatDateLong(property.date)}
                </Typography>
              </Box>

              {/* days left */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                <AccessTimeIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography
                  sx={{
                    fontSize: '0.72rem',
                    fontWeight: 700,
                    color:
                      daysLeft === null
                        ? '#1976d2'
                        : daysLeft === 0
                        ? '#e53935'
                        : daysLeft <= 7
                        ? '#ff9800'
                        : '#2e7d32',
                  }}
                >
                  {daysLeft === null
                    ? 'No Expiry'
                    : daysLeft === 0
                    ? 'Expired'
                    : `${daysLeft} days left`}
                </Typography>
              </Box>

              {/* price band */}
              <Box
                sx={{
                  mt: 0.4,
                  px: 1,
                  py: 0.7,
                  borderRadius: '8px',
                  backgroundColor: colors.goldSoft,
                  border: `1px dashed ${colors.gold}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '0.58rem',
                    fontWeight: 700,
                    color: '#8a6a1f',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    lineHeight: 1.1,
                  }}
                >
                  Rent
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.85rem',
                    fontWeight: 800,
                    color: colors.gold,
                    whiteSpace: 'nowrap',
                  }}
                >
                  ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ============ SPEC GRID (2 columns) ============ */}
          <Box
            sx={{
              mx: 1.2,
              mb: 1,
              border: `1px solid ${colors.line}`,
              borderRadius: '10px',
              overflow: 'hidden',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              backgroundColor: colors.specBg,
            }}
          >
            {specs.map((spec, index) => (
              <SpecCell
                key={spec.label}
                icon={spec.icon}
                label={spec.label}
                value={spec.value}
                index={index}
                total={specs.length}
              />
            ))}
          </Box>

         {/* ============ FOOTER: EXTEND + VIEW + WISHLIST + EDIT + DELETE ============ */}
<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 0.8,
    px: 1.2,
    py: 1,
    borderTop: `1px solid ${colors.line}`,
    backgroundColor: '#FAF8F5',
    flexWrap: 'wrap',
  }}
>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
    {/* Extend Your Post */}
    <Button
      variant="outlined"
      disabled={daysLeft !== null && daysLeft > 7}
      onClick={handleExtensionClick}
      startIcon={<AccessTimeIcon sx={{ fontSize: 15, color: '#c3790b' }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: '#d0d0d0',
        color: '#c3790b',
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#d0d0d0' },
        '&.Mui-disabled': {
          backgroundColor: '#fff',
          borderColor: '#d0d0d0',
          color: '#c3790b',
          opacity: 0.6,
        },
      }}
    >
      Extend Your Post
    </Button>

    {/* View */}
    <Box
      onClick={(e) => handleViewListClick(property.id, e)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <VisibilityIcon sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        View ({property.viewCount || 0})
      </Typography>
    </Box>

    {/* Wishlist */}
    <Box
      onClick={(e) => handleWishlistClick(property.id, e)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: '7px',
        border: `1px solid ${colors.line}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#F5F0E8' },
      }}
    >
      <FavoriteBorder sx={{ fontSize: 13, color: '#5a5a5a' }} />
      <Typography sx={{ fontSize: '0.66rem', fontWeight: 600, color: '#5a5a5a' }}>
        Wishlist ({property.wishlistCount})
      </Typography>
    </Box>
  </Box>

  {/* ── EDIT + DELETE at the very end ── */}
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 'auto' }}>
    {/* Edit */}
    <Button
      variant="outlined"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/user-edit-rent/${property.id}`);
      }}
      startIcon={<EditOutlinedIcon sx={{ fontSize: 14 }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: 'rgba(184,134,11,0.5)',
        color: colors.gold,
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'rgba(184,134,11,0.08)',
          borderColor: colors.gold,
        },
      }}
    >
      Edit
    </Button>

    {/* Delete */}
    <Button
      variant="outlined"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        setMenuPropertyIdToDelete(property.id);
        setShowDeleteConfirm(true);
      }}
      startIcon={<DeleteOutline sx={{ fontSize: 14 }} />}
      sx={{
        textTransform: 'none',
        borderRadius: '7px',
        fontSize: '0.66rem',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderColor: 'rgba(231,76,60,0.5)',
        color: colors.danger,
        px: 1,
        py: 0.4,
        whiteSpace: 'nowrap',
        minWidth: 0,
        '&:hover': {
          backgroundColor: 'rgba(231,76,60,0.08)',
          borderColor: colors.danger,
        },
      }}
    >
      Delete
    </Button>
  </Box>
</Box>
        </CardContent>
      </Card>
    );
  };

  // ==================== MAIN RENDER ====================
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: colors.background,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading Rent properties...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: colors.background, minHeight: '120vh' }}>
      {/* Fixed Top Section */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          backgroundColor: colors.background,
          px: 1,
          py: 1,
          boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
        }}
      >
        <CustomSearchBar value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />

        <Box sx={{ mt: 1, px: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            My Rent Properties
          </Typography>

          {filteredProperties.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleBoostProperty}
              disabled={boostLoading}
              startIcon={!boostLoading && <RocketIcon sx={{ fontSize: 18 }} />}
              sx={{
                fontSize: '0.75rem',
                fontWeight: 600,
                textTransform: 'none',
                backgroundColor: '#6B3620',
                color: '#FFFFFF',
                borderRadius: '8px',
                padding: '6px 16px',
                '&:hover': { backgroundColor: '#8A4A2E' },
                '&.Mui-disabled': {
                  backgroundColor: '#6B3620',
                  color: '#FFFFFF',
                  opacity: 0.7,
                },
              }}
            >
              {boostLoading ? (
                <CircularProgress size={20} sx={{ color: 'white' }} />
              ) : (
                'Boost Your Property'
              )}
            </Button>
          )}
        </Box>
      </Box>

      {/* Property List Section */}
      <Box sx={{ pt: { xs: '90px', sm: '150px' }, pb: 8 }}>
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => renderRentPropertyCard(property))
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', px: 2 }}>
            <Typography>No properties found matching your search.</Typography>
          </Box>
        )}
      </Box>

      {/* ALERTS */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showShareSuccess && (
        <ShareCopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowShareSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showShareFailure && (
        <ShareCopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowShareFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage('');
          }}
        />
      )}
      {showDeleteConfirm && (
        <DeleteConfirmAlert
          message={`Are you sure you want to delete property ID ${menuPropertyIdToDelete}?`}
          onOk={() => {
            setShowDeleteConfirm(false);
            handleDelete();
          }}
          onCancel={() => {
            setShowDeleteConfirm(false);
            setMenuPropertyIdToDelete(null);
          }}
        />
      )}
      {showBoostSuccess && (
        <BoostSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowBoostSuccess(false);
            setAlertMessage('');
          }}
        />
      )}
      {showBoostFailure && (
        <BoostFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowBoostFailure(false);
            setAlertMessage('');
          }}
        />
      )}

      <BottomNavbar />
    </Box>
  );
};

export default RentPropertyCard;